import { auth0 } from "@/auth/_globals.js";

export default {
	install(app) {
		app.use(auth0);
	}
};
